<template>
  <div class="samaple__conntents">
    <div style="margin-top: 20px;">
      <div class="my_rule_message">こちらの検証方法ですが、以下のマイルールに基づいて算出していますのでご理解の上よろしくお願いいたします。</div>
      <div class="my_rule_message">1、推奨の1点の金額があるサイトは最低額を採用しています。</div>
      <div class="my_rule_message">2、推奨の1点の金額がない場合は、10点までなら500円、10点以上は300円。もし、300円で購入しても10000円を超える場合は10000円に収まるように調整しています。</div>
      <div class="my_rule_message">3、予想レース数が多いサイトは、重賞のみとしています。(独断ですみません。現状1サイトが該当します)</div>
      <div class="my_rule_message">4、あまりにも収支結果がマイナスの場合は検証対象サイトから外して、その代わり新たなサイトを検証対象に入れます。10サイトを下回ることはないかと(独断ですみません)</div>
      <div class="my_rule_message">5、本命馬券と穴馬券など2パターン用意している場合は、傾向をみて回収率が高い方を採用します。(独断ですみません。現状1サイトが該当します)</div>
      <div class="my_rule_message">6、手動で収集、検証をしているため万が一誤記等があるかもしれませんが、一切の責任は負いませんのでご理解ください(捏造とか詐欺の意図は全くなです、ミスがないように細心の注意を払ってやっていますが、ミスったらごめんなさいm(_ _)m)</div>
      <div class="my_rule_message">7、たまに寝坊などして、朝公開の予想の閲覧し忘れがあります。。この点もご了承いただければ。。。これも当然、捏造等の意図はないです。むしろ予想サイト運営者の方々が「せっかく当たっているのに見逃しやがって！！」とお怒りになるパターンですね。。もしそのような場合は大変申し訳ありません。</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import vueGoodTable from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
 
Vue.use(vueGoodTable)
export default {
  data() {
    return {}
  },
  methods: {}
}
</script>
<style>
.samaple__conntents {
  margin: 0 auto;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.my_rule_message {
  color:blue;
  margin: 0 auto;
  font-size: 16px;
  text-align: left;
}

.midashi {
  font-size: 32px;
  color: #364e96;/*文字色*/
  padding: 0.5em 0;/*上下の余白*/
  border-top: solid 3px #364e96;/*上線*/
  border-bottom: solid 3px #364e96;/*下線*/
}
</style>